import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit'
import React from 'react'

function FullFinancedErrorPage(props) {
  const { Config, EpiContext } = props
  return (
    <div className='full-financed-error-page'>
      <div className='img-container'>
        <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M73.636 81.818c-2.272 2.727-6.86 5.454-13.636 5.455-6.776 0-11.364-2.728-13.636-5.454" stroke="var(--theme-primary, #810ea9)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
          <circle cx="60" cy="49.091" r="27.273" stroke="#000" stroke-width="2.5" />
          <path d="M27.273 98.182c5.454-10.91 16.463-21.818 32.726-21.819 16.263 0 27.274 10.91 32.728 21.816" stroke="#000" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <div className='text-container'>
        <span>היי, ראינו שניסית להיכנס לאזור האישי
          הכניסה היא ללקוחות פרטיים בלבד</span>
      </div>
      <div className='buttons-container'>
        <BtnSubmit onclick={() => EpiContext.navigateTo(Config.abroadUrl)} text='לרכישת חבילת חו״ל'></BtnSubmit>
        <BtnSubmit onclick={() => EpiContext.navigateTo(Config.businessLandPageUrl)} text='לעמוד הבית העסקי'></BtnSubmit>
      </div>
    </div>
  )
}

export default FullFinancedErrorPage
